export default __webpack_public_path__ + "static/media/lung_risk.5ba4b57e.jpg";